import { createFileRoute } from "@tanstack/react-router";
import { signUpRoute, SignUpRoute } from "@/features/account-access";

export const Route = createFileRoute("/sign-up")({
    validateSearch: signUpRoute.validateSearch,
    ssr: signUpRoute.ssr,
    head: signUpRoute.head,
    component: SignUpRoute,
});
